<div class="modal-title"><span class="text-primary">{{ 'dealer:offer:order:confirm:title' | translate }}</span></div>
<div class="modal-template">
    <p>{{ 'dealer:offer:order:confirm:message' | translate }}</p>
</div>
<div class="modal-footer">
    <button (click)="confirm()" class="btn-primary btn-block btn-large">
        {{ 'dealer:offer:order:confirm:button' | translate }}
    </button>
</div>
